"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupQueryConfig = void 0;
var lodash_1 = __importDefault(require("lodash"));
var setupQueryConfig = function (variables, options) {
    var cacheOptions = {
        fetchPolicy: 'no-cache',
    };
    return lodash_1.default.merge(cacheOptions, { variables: variables }, options);
};
exports.setupQueryConfig = setupQueryConfig;
